import Component from '../abstracts/Component';
import TrackingComponent from './TrackingComponent';
import OnDemandLiveRegion from '../utils/OnDemandLiveRegion';

export default class NotifyMeComponent extends Component {

  get COMPONENTNAME() {
    return 'NotifyMeComponent';
  }

  get SELECTORS() {
    return {
      notifySubmitBtn: '[data-js-notifyme-submit]',
      notifyForm: '[data-js-form]',
      notifyConfirm: '[data-js-confirm]',
      notifyConfirmText: '[data-js-confirm-text]',
      notifyInput: 'input[type="email"]',
      errorMsg: '[data-js-error]',
      formWrapper: '[data-js-form-wrapper]'
    };
  }

  constructor(compEl) {
    super(compEl);
    this.TrackingComponent = new TrackingComponent();
    this.liveRegion = new OnDemandLiveRegion({
      level: 'assertive',
      delay: 1000,
    });
  }

  readDOM() {
    return {
      notifySubmitBtn: document.querySelector(this.SELECTORS.notifySubmitBtn),
      notifyForm: this.$component.querySelector(this.SELECTORS.notifyForm),
      notifyConfirm: this.$component.querySelector(this.SELECTORS.notifyConfirm),
      notifyConfirmText: this.$component.querySelector(this.SELECTORS.notifyConfirmText),
      errorMsg: this.$component.querySelector(this.SELECTORS.errorMsg),
      formWrapper: this.$component.querySelector(this.SELECTORS.formWrapper),
    };
  }

  // FETCH //
  submitForm(notifyForm, notifySubmitBtn, notifyConfirm, notifyMeFormEmail, sizeSelector = null) {
    const url = notifyForm.action;
    const data = new FormData(notifyForm);
    const notifyInput = notifyForm.querySelector(this.SELECTORS.notifyInput);


    this.toggleSubmitButtonLoading(notifySubmitBtn, true);

    // Trova la select della taglia
    const selectEl = sizeSelector ? sizeSelector.querySelector('select[data-size-select="true"]') : null;
    const selectedSize = selectEl ? selectEl.value : null;

    // Se la taglia NON è selezionata (valore vuoto o non valido)
    if (!selectedSize || selectedSize === '') {
      if (sizeSelector) {
        const selectEl = sizeSelector.querySelector('select[data-size-select="true"]');
        const placeholder = selectEl ? selectEl.getAttribute('data-placeholder') : null;
        this.liveRegion.sayMessage(placeholder);
      }
    }

    fetch(url, {
      method: 'POST',
      body: data
    })
      .then(response => {
        if (response.ok) {
          return response.text().then(text => {
            this.toggleError(notifyForm, notifyInput, true, data.get("size"), sizeSelector);
            if (notifyConfirm) {
              const confirmTextEl = notifyConfirm.querySelector(this.SELECTORS.notifyConfirmText);
              if (confirmTextEl) {
                confirmTextEl.innerHTML = text;
              }
              notifyConfirm.classList.remove("hidden");
            }
            notifyForm.classList.add("hidden");
            notifySubmitBtn.classList.add("hidden");
            this.dom?.formWrapper?.classList.add("hidden");
            if (notifyMeFormEmail) {
              notifyMeFormEmail.classList.add("hidden");
            }
            this.toggleSubmitButtonLoading(notifySubmitBtn);
            const productCode = data.get("productCode");
            if (productCode) {
              this.TrackingComponent.actions.notifyMe(productCode);
            }
          })
        } else {
          this.toggleError(notifyForm, notifyInput, false, data.get("size"), sizeSelector);
          this.toggleSubmitButtonLoading(notifySubmitBtn);
          notifySubmitBtn.disabled = false;
        }
      })
      .catch((error) => {
        this.warn(error);
        this.toggleError(notifyForm, notifyInput, false, data.get("size"), sizeSelector);
        this.toggleSubmitButtonLoading(notifySubmitBtn);
        notifySubmitBtn.disabled = false;
      });
  }

  // submit form
  bindSubmit() {
    if (this.dom.notifyForm) {
      this.dom.notifyForm.addEventListener("submit", (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (this.dom.notifySubmitBtn && !this.dom.notifySubmitBtn.disabled) {
          this.dom.notifySubmitBtn.disabled = true;
          this.submitForm(this.dom.notifyForm, this.dom.notifySubmitBtn, this.dom.notifyConfirm);
        }
      });
    }

    if (this.dom.notifySubmitBtn) {
      this.dom.notifySubmitBtn.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (this.dom.notifySubmitBtn.disabled === true) {
          return;
        }

        this.dom.notifySubmitBtn.disabled = true;
        this.submitForm(this.dom.notifyForm, this.dom.notifySubmitBtn, this.dom.notifyConfirm);
      });
    }
  }

  toggleSubmitButtonLoading(notifyMeSubmitButton, loading = false) {
    if (notifyMeSubmitButton) {
      if (loading) {
        notifyMeSubmitButton.classList.add('--loading');
      } else {
        notifyMeSubmitButton.classList.remove('--loading');
      }
    }
  }

  toggleError(notifyForm, notifyInput, hideError = false, size = null, sizeSelector = null) {
    const errorMsg = notifyForm.querySelector(this.SELECTORS.errorMsg);

    if (hideError) {
      notifyForm ? notifyForm.querySelector(this.SELECTORS.errorMsg).classList.add("hidden") : '';
      notifyInput ? notifyInput.classList.remove('error') : '';
      sizeSelector ? sizeSelector.classList.remove('error') : '';
    } else {
      if (!size || size == '') {
        if (sizeSelector) {
          // case for wishlist
          sizeSelector.classList.add('error');
          errorMsg.innerHTML = '';
        } else {
          errorMsg.innerHTML = errorMsg.dataset.nosizeSelected;
        }
      } else {
        errorMsg.innerHTML = errorMsg.dataset.jsError;
      }
      notifyForm ? notifyForm.querySelector(this.SELECTORS.errorMsg).classList.remove("hidden") : '';
      notifyInput && (size && size !== '') ? notifyInput.classList.add('error') : '';
    }
  }

  render() {
    this.log("Rendering...");
    this.dom = this.readDOM();
    this.bindSubmit();
  }
}
